import * as React from "react";
import {Types}    from "@Common/types";

import {cs} from "@Common/react/chain-services";

import {Responsive}               from "@Common/ui-components/responsive";

import {AccountTabsLayout}        from "../../../common/account-tabs-layout/account-tabs-layout";
import {UserManagementController} from "./user-management-controller";
import {UserManagementLayout}     from "./user-management-layout";
import {UserManagementLayoutMobile} from "./user-management-layout-mobile";

export const AccountUserManagementRoute = () => cs(
    (_, next)           => AccountTabsLayout({
        activeMenu: "userManagement",
        activeTab: "user-management",
        config: [],
        next,
    }),
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            md: 1024,
        },
        next,
    }}/>],
    ["controller", (_, next) => <UserManagementController next={next}/>],
    ({responsive, controller}:{responsive:Types.Common.UiComponents.Responsive.ResponsiveNext, controller:Types.Xpresso.Account.Admin.UserManagement.UserManagementControllerNext}) => (
        responsive.ge("md") ? (
            <UserManagementLayout
                canLoadMore={!controller.done}
                isLoading={controller.fetching}
                onBranchChangeRequest={controller.handleBranchChangeRequest}
                onColumnCountChange={controller.handleColCountChange}
                onLoadMoreRequest={controller.handleLoadMoreRequest}
                onSearchChangeRequest={controller.handleSearchChangeRequest}
                onShowInactiveSwitchRequest={controller.handleIncludeInactiveSwitchRequest}
                onUserCreateRequest={controller.handleUserCreateRequest}
                reload={controller.reload}
                searchIsActive={Boolean(controller.search)}
                showingInactive={controller.includingInactive}
                users={controller.users}
            />
        ) : (
            <UserManagementLayoutMobile
                canLoadMore={!controller.done}
                    isLoading={controller.fetching}
                    onBranchChangeRequest={controller.handleBranchChangeRequest}
                    onColumnCountChange={controller.handleColCountChange}
                    onLoadMoreRequest={controller.handleLoadMoreRequest}
                    onSearchChangeRequest={controller.handleSearchChangeRequest}
                    onShowInactiveSwitchRequest={controller.handleIncludeInactiveSwitchRequest}
                    onUserCreateRequest={controller.handleUserCreateRequest}
                    reload={controller.reload}
                    searchIsActive={Boolean(controller.search)}
                    showingInactive={controller.includingInactive}
                    users={controller.users}
            />
        )
    ),
);
